module.exports = __webpack_public_path__ + "343cd60c5ec6953e288c0ec733c7a4ca.pdf";